module.exports = __webpack_public_path__ + "static/5@3x-60cb1365c35f1b27b6ecd90d154272b9.png";